module.exports = "<div class=\"mapPoint\" ng-click=\"$ctrl.openLocation()\">\n  <md-icon>my_location</md-icon>\n  {{ ::$ctrl.title }}\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/mapPoint/mapPoint.html
// module id = 991
// module chunks = 0